$(document).ready(function () {
  // header drawer code start
  $("button.mobileMenuOpener").click(function () {
    $("#mobile-header").toggleClass("mobileMenuOpen");
    $(".header--classic").toggleClass("mobileMenuIsOpen");
    $("html, body").toggleClass("hideScroll");
  });
  var caretIcon = $("#dropDownIconDemo").html();
  $(".mobile-menu__first-level span.close-dropdown").html(caretIcon);
  // header drawer code end

  // hero video play button code start
  $("button.playIconBtn").click(function () {
    $(this).parent(".videoCoverContent").addClass("videoIsPlaying");
    var videoId = $(this).attr("data-VideoId");
    console.log(videoId);
    $(videoId).trigger("play");
    //  $('video').trigger('pause');
  });
  $("button.pauseIconBtn").click(function () {
    $(this).prev(".videoCoverContent").removeClass("videoIsPlaying");
    var videoId = $(this).attr("data-VideoId");
    console.log(videoId);
    $(videoId).trigger("pause");
  });
  // hero video play button code end

  // image with text accordian code start
  $(".underInfoAccordian").click(function () {
    $(".underInfoAccordian").not(this).removeClass("isOpen");
    $(this).toggleClass("isOpen");
  });

  // image with text accordian code start
  // faq page code start
  $(".faqCatBtn").click(function () {
    $(".faqCatBtn").removeClass("activeTabBtn");
    $(this).addClass("activeTabBtn");
    var accordianContent = $(this).attr("data-id");
    $(".faqCatBlock").hide();
    $(accordianContent).fadeIn(500);
  });
  // faq page code end

  // Tab Section  code start
  $("button.tabBtn").click(function () {
    var tabContentId = $(this).attr("data-id");
    $(".tabBtn").removeClass("activeTabBtn");
    $(".tabContent").hide();
    $(this).addClass("activeTabBtn");
    $(tabContentId).fadeIn(500);
    let slider = $(tabContentId)
      .children(".beforeAfterSecRow")
      .find(".beforeAfterSlider");
    let beforeImage = $(tabContentId)
      .children(".beforeAfterSecRow")
      .find(".beforeItem img");
    let width = slider.width();
    console.log(width);
    beforeImage.width(width + "px");
  });
  // Tab Section  code end

  //   price change in button on option click code start
  $(".swatch__options").click(function () {
    setTimeout(function () {
      var prodPriceDefault = $("#productPageProdPrice .price span.money").text();
      $("b#productPriceOnBuyBtn").text(prodPriceDefault);
      $("b#productPriceOnBuyBtn").show(200);

      var ftProdPriceDefault = $("#featuredProdPrice .price span.money").text();
      $("b#ftProductPriceOnBuyBtn").text(ftProdPriceDefault);
      $("b#ftProductPriceOnBuyBtn").show(200);

      var mainFormBtnTxt = $("#productPriceOnBuyBtn").text();
  $("#extraAddToCartBtn .extraPrice").text(mainFormBtnTxt);
      
    }, 1500);
  });

  //   price change in button on option click code end
});

// before after slider code start
const beforeItemSection = document.querySelectorAll(".beforeAfterSlider");
const beforeItemContainer = [...beforeItemSection];

beforeItemContainer.forEach((slider) => {
  const before = slider.querySelector(".beforeItem");
  const beforeImage = before.getElementsByTagName("img")[0];
  const beforeAfterResizer = slider.querySelector(".beforeAfterResizer");

  let active = false;

  //Sort overflow out for Overlay Image
  document.addEventListener("DOMContentLoaded", function () {
    let width = slider.offsetWidth;
    console.log(width);
    beforeImage.style.width = width + "px";
  });

  //Adjust width of image on resize
  window.addEventListener("resize", function () {
    let width = slider.offsetWidth;
    console.log(width);
    beforeImage.style.width = width + "px";
  });

  beforeAfterResizer.addEventListener("mousedown", function () {
    active = true;
    beforeAfterResizer.classList.add("resize");
  });

  document.body.addEventListener("mouseup", function () {
    active = false;
    beforeAfterResizer.classList.remove("resize");
  });

  document.body.addEventListener("mouseleave", function () {
    active = false;
    beforeAfterResizer.classList.remove("resize");
  });

  document.body.addEventListener("mousemove", function (e) {
    if (!active) return;
    let x = e.pageX;
    x -= slider.getBoundingClientRect().left;
    slideIt(x);
    pauseEvent(e);
  });

  beforeAfterResizer.addEventListener("touchstart", function () {
    active = true;
    beforeAfterResizer.classList.add("resize");
  });

  document.body.addEventListener("touchend", function () {
    active = false;
    beforeAfterResizer.classList.remove("resize");
  });

  document.body.addEventListener("touchcancel", function () {
    active = false;
    beforeAfterResizer.classList.remove("resize");
  });

  //calculation for dragging on touch devices
  document.body.addEventListener("touchmove", function (e) {
    if (!active) return;
    let x;

    let i;
    for (i = 0; i < e.changedTouches.length; i++) {
      x = e.changedTouches[i].pageX;
    }

    x -= slider.getBoundingClientRect().left;
    slideIt(x);
    pauseEvent(e);
  });

  function slideIt(x) {
    let transform = Math.max(0, Math.min(x, slider.offsetWidth));
    before.style.width = transform + "px";
    beforeAfterResizer.style.left = transform - 0 + "px";
  }

  //stop divs being selected.
  function pauseEvent(e) {
    if (e.stopPropagation) e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
    e.cancelBubble = true;
    e.returnValue = false;
    return false;
  }
});

// before after slider code end
